import { ContactFinanceType } from "@/enums/enums";
import { MerchantId, SetHeaderService } from "@/helper/userHelper";
import { i18n } from "@/i18n";
import service from "../baseHttpService";
class ContactService {
  DoGetContactByContactIdList(contactIdList: Array<number>) {
    const _input = {
      merchantId: MerchantId(),
      contactIdList: contactIdList,
      language: i18n.locale,
    };
    return service.peakExportAPI
      .post("/api/Contact/GetContactByContactIdList", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoGetContactSearchFirst(contactFinanceType: ContactFinanceType) {
    const _input = {
      contactFinanceType: contactFinanceType,
    };
    return service.peakRealTimeAPI
      .post("/api/Contact/GetContactSearchFirst", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoGetContactSearchWithSearchText(searchText: string, contactFinanceType: ContactFinanceType) {
    const _input = {
      searchText: searchText,
      contactFinanceType: contactFinanceType,
    };
    return service.peakRealTimeAPI
      .post("/api/Contact/GetContactSearchWithSearchText", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
}

export default new ContactService();
